import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { ProductImageSizesPortraitEnum } from '@as-react/common-types';
import { useAemConfig } from '@as-react/common-components';
import { findColor } from '@as-react/common-utils';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { getPortraitImageSizeUrlByProductCode } from '../../../util/ImageUtil';
import { getProductDetailUrl } from '../../../util/ProductUtil';
import { Box, Checkbox, IconButton, Link, ProductTile, ProductTileHorizontal, Rating, StackBlock, StackInline, TextAlpha, } from '@yonderland/andes-react';
import { HeartFillIcon, HeartIcon } from '@yonderland/andes-icons';
import { ProductImageHeight, ProductImageWidth } from '../../../constants/ProductConstants';
import { usePriceProps } from '../../../hooks/usePriceProps';
export const AlternativeProductTileAlpha = ({ product, onWishListToggle, updateCompareList, }) => {
    var _a;
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const { root, isShopLanding, feature_toggles: { product_compare, lowest_price_all }, productImageConfig, } = useAemConfig();
    const selectedColor = findColor(product.colours, product.colourId);
    const productUrl = getProductDetailUrl(product, root);
    const compareCheckboxId = `product-compare-alternative-${product.productCode}-${product.colourId}`;
    const priceProps = usePriceProps({
        priceInformation: {
            prices: selectedColor.prices,
            hasDiscount: selectedColor.hasDiscount,
        },
        enablePriceReference: lowest_price_all,
    });
    const image = getPortraitImageSizeUrlByProductCode(product.productCode, selectedColor.image, productImageConfig.cdnDomains, ProductImageSizesPortraitEnum.basket);
    const handleWishListClick = (e) => {
        e.stopPropagation();
        onWishListToggle({
            productCode: product.productCode,
            productId: product.productId,
            colorId: selectedColor.colourId,
        });
    };
    const handleCompareChange = () => {
        updateCompareList({
            brand: product.brand,
            color: selectedColor.colourId,
            image: selectedColor.image,
            productCode: product.productCode,
            selected: false,
            id: product.productId,
            title: product.title,
            gender: product.genderCode,
            url: productUrl,
            colorDescription: selectedColor.description,
            collapsedComparePopup: true,
        });
    };
    return (_jsxs(ProductTileHorizontal, { testId: "product-alternative-tile", product: Object.assign({ image, alt: product.title, title: product.title, brand: product.brand }, priceProps), children: [_jsx(ProductTile.Cell, { section: "media", children: _jsx(ProductTile.Image, { lazyLoad: true, width: ProductImageWidth.ALTERNATIVE_TILE, height: ProductImageHeight.ALTERNATIVE_TILE, url: productUrl }) }), _jsx(ProductTile.Cell, { section: "content", children: _jsxs(StackBlock, { gap: "2", itemsAlign: "stretch", children: [_jsxs(StackInline, { gap: "2", wrap: "nowrap", itemsAlign: "start", children: [_jsx(Box, { flex: { grow: 1 }, children: _jsx(ProductTile.Title, { brandOnTheSameLine: true, lineClamp: 2, url: productUrl }) }), !isShopLanding && (_jsx(IconButton, { onClick: handleWishListClick, variant: "plain", size: "sm", icon: {
                                        source: selectedColor.inWishList ? HeartFillIcon : HeartIcon,
                                        size: 'sm',
                                        animation: selectedColor.inWishList ? 'pulse' : undefined,
                                    }, testId: "product-alternative-wishlist-button" }))] }), _jsxs(StackBlock, { gap: "2", children: [!!product.productRating && (_jsxs(StackInline, { gap: "1", itemsAlign: "center", children: [_jsx(Rating, { rating: product.productRating, readOnly: true }), _jsx(Link, { size: "sm", variant: "secondary", theme: "neutral", href: productUrl, children: (_a = product.productReviews) !== null && _a !== void 0 ? _a : 0 })] })), _jsx(ProductTile.Price, {}), _jsxs(TextAlpha, { variant: "bodyS", color: "subtle", children: [product.colours.length, " ", t('lister.swatch.counter', { count: product.colours.length })] })] }), product_compare && (_jsx(Checkbox, { id: compareCheckboxId, name: compareCheckboxId, value: compareCheckboxId, label: t('productCompare.pdp.checkbox'), checked: selectedColor.isCompareProduct || false, onChange: handleCompareChange, testId: "product-alternative-compare-checkbox" }))] }) })] }));
};
